import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';
import Button from '@fhnw/components/Button/Button';
import { ASPECT_MAP } from '@fhnw/customizations/@kitconcept/volto-light-theme/components/Blocks/Image/View';

const messages = defineMessages({
  square: {
    id: 'Quadrat',
    defaultMessage: 'Quadrat',
  },
  landscape: {
    id: 'Querformat',
    defaultMessage: 'Querformat',
  },
  wide: {
    id: 'Panorama',
    defaultMessage: 'Panorama',
  },
  portrait: {
    id: 'Portrait',
    defaultMessage: 'Portrait',
  },
  original: {
    id: 'Original',
    defaultMessage: 'Original',
  },
});
//props definition as needed in typescript
export interface FormatWidgetProps {
  actions?: any;
  actionsInfoMap?: any;
  defaultAction: string;
  id: string;
  onChange: Function;
  value: string | { token: string };
  disabled: boolean;
  default: string;
}

const FormatWidget: React.FC<FormatWidgetProps> = (props) => {
  const { id, onChange, defaultAction, disabled } = props;

  React.useEffect(() => {
    if (!props.value && props.default) {
      props.onChange(props.id, props.default);
    }
  });
  const intl = useIntl();
  const actions = ['landscape', 'portrait', 'square', 'wide', 'none'];
  const defaultActionsInfo = () => ({
    landscape: intl.formatMessage(messages.landscape),
    wide: intl.formatMessage(messages.wide),
    square: intl.formatMessage(messages.square),
    portrait: intl.formatMessage(messages.portrait),
    none: intl.formatMessage(messages.original),
  });

  const actionsInfo: any = {
    ...defaultActionsInfo(),
  };

  let value = props?.value;
  if (typeof value === 'object' && value?.token) {
    value = value.token;
  }
  if ((value as string) in ASPECT_MAP) {
    value = ASPECT_MAP[value as keyof typeof ASPECT_MAP];
  }

  return (
    <FormFieldWrapper {...props} className="format-widget">
      <div className="format-buttons">
        {actions.map((action) => (
          <div key={action}>
            <Button
              label={actionsInfo[action]}
              className={
                (action === defaultAction && !value) || value === action
                  ? 'active-format-button'
                  : 'format-button'
              }
              onPress={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onChange(id, action);
              }}
              size="small"
              type={
                (action === defaultAction && !value) || value === action
                  ? 'submit'
                  : 'button'
              }
              isDisabled={disabled}
              styles={''}
            />
          </div>
        ))}
      </div>
    </FormFieldWrapper>
  );
};

export default FormatWidget;
